var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MobileBasePage } from '../../core/base/mobile-base-page';
import { Item, OrderManager } from 'aigens-ng-core';
import { AfterViewInit, ChangeDetectorRef, ElementRef, Injector, OnDestroy, OnInit } from '@angular/core';
import { VariationDialog } from '../../dialogs/variation/variation';
import { IonContent, IonFab } from '@ionic/angular';
import { from, Observable, timer } from 'rxjs';
import { MultiStepComboPage } from 'src/app/routes/item/multi-step-combo/multi-step-combo-page.component';
import { getCategoryPage, getSetLayout } from '../../shared/utilities/layout-helper';
import { ModifierDialog } from '../../dialogs/modifier/modifier';
import { ModifierItemSelectPageModal } from 'src/app/routes/item/modifier-item-select-modal/modifier-item-select-modal';
import { VariationScrollDialog } from 'src/app/dialogs/variation-scroll/variation-scroll';
import { ComboPage } from 'src/app/routes/item/combo-page/combo-page';
import { SideBarModifierDialog } from 'src/app/dialogs/sideBarModifier/sideBarModifier';
var ItemGridPage = /** @class */ (function (_super) {
    __extends(ItemGridPage, _super);
    function ItemGridPage(injector, cd) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.cd = cd;
        _this.isfabOpen = false;
        _this.isVariationOpened = false;
        _this.shouldAnimate = true;
        _this.bounceState = 'noBounce';
        _this.isBounce = false;
        _this.imgs = [];
        _this.soldoutMap = {};
        _this.modifiableMap = {};
        _this.requiredModifierMap = {};
        _this.tagsImage = {};
        _this.currLang = _this.t.currentLang;
        _this.allItems = {};
        _this.allItemsArray = [];
        _this.displayItems = [];
        _this.lengthArrayOfEachCategoryItems = [];
        _this.displayItemsTittle = [];
        _this.variations = {};
        _this.itemHeight = 100;
        _this.headerHeight = 32;
        _this.rcats = [];
        _this.alert = null;
        _this.tabClickCount = 0;
        _this.setClickCount = 0;
        _this.adShown = false;
        _this.login = false;
        _this.itemSoldoutMap = {};
        _this.fromBrandStoreList = false;
        _this.normalCategories = [];
        _this.noCat = false;
        _this.infiniteIsHidden = true;
        _this.catTitHeightArr = [];
        _this.lazyLoad = false; // 当前页面的懒加载设置开关
        _this.imgsObj = {};
        _this.isIonContentScroll = true;
        _this.itemMap = {};
        _this.imageMap = {};
        _this.categoryMap = {};
        _this.isImplementGostore = true;
        _this.displayCat = {};
        _this.backBySwitchStore = false;
        console.log('TCL: ItemGridPage');
        _this.store = _this.getNavParams('store');
        _this.storeId = _this.store.id;
        _this.selectedValue = _this.store && "" + _this.store.id;
        _this.currentSelectedValue = _this.selectedValue;
        _this.categories = _this.getNavParams('categories');
        _this.stores = _this.getNavParams('stores');
        _this.storeClicked = _this.getNavParams('storeClicked');
        _this.defaultImage = _this.getDefaultImage(false, _this.store.brand, 500);
        _this.isCatLayoutNone = !_this.settings.catLayout || _this.settings.catLayout === 'none';
        _this.fromBrandStoreList = _this.getNavParams('fromBrandStoreList');
        // console.log('this.configService.getTime()', this.configService.getTime());
        // console.log('nownow', now.getTime());
        console.log('settings', _this.settings);
        if (_this.store && _this.store.menu) {
            _this.itemMap = _this.store.menu['imap'];
        }
        _this.isInfiniteScroll = _this.settings['enableInfiniteScroll'] || false;
        if (_this.isCatLayoutNone) {
            _this.catLayoutIsNone();
        }
        else {
            _this.category = _this.getNavParams('category');
            _this.mode = _this.getNavParams('layout') ? _this.getNavParams('layout') : _this.settings.itemLayout;
            console.log('item grid construction', _this.mode);
            console.log('this.categories', _this.categories);
            if (_this.multOrderManager.enableMutlOrder) {
                _this.settingMutlOrderManager();
            }
        }
        if (_this.fromBrandStoreList) {
            _this.checkPopup(_this.store);
        }
        return _this;
    }
    ItemGridPage.getPageUrl = function () {
        return 'item-grid';
    };
    ItemGridPage.prototype.canDeactivate = function () {
        var _this = this;
        if (this.backBySwitchStore)
            return Observable.of(true);
        // if any category layout is set in menu settings, then ItemGridPage is not the last page
        if (this.store.menu.catLayout && this.store.menu.catLayout !== 'none') {
            return Observable.of(true);
        }
        var modal = from(this.modalController.getTop());
        {
            modal.subscribe(function (m) {
                if (m) {
                    m.dismiss();
                    _this.navigationService.isAlertingDeactive = false;
                    _this.navigationService.poping = false;
                    _this.navController.setDirection('forward', true, 'forward');
                    window.history.pushState({}, 'Order.Place', window.location.href);
                    // TODO: the history is still popped even the navigation is cancelled so we push it back to history stack.
                    console.log('push state', window.location.href);
                    _this.navigationService.deactivateResult.next(false);
                }
                else {
                    console.log('guard running');
                    // this.navigationService.deactivateResult.next(false);
                    if (_this.multOrderManager.enableMutlOrder) {
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    if (!_this.navigationService.poping) {
                        // this.navController.setDirection('back', true, 'back');
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    if (_this.noCat) {
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
                    try {
                        console.log('creating alert?', _this.navigationService.isAlertingDeactive);
                        if (!_this.navigationService.isAlertingDeactive) {
                            _this.navigationService.isAlertingDeactive = true;
                            var alert_1 = _this.alertController.create({
                                header: _this.t.instant('pages.brand-store-list.alert-title'),
                                backdropDismiss: false,
                                buttons: [
                                    {
                                        text: _this.t.instant('buttons.cancel'),
                                        handler: function () {
                                            // to do
                                            // this.googleAnalyticEventTrack('back-button-event', 'cancel');
                                            _this.navigationService.isAlertingDeactive = false;
                                            _this.navigationService.poping = false;
                                            _this.navController.setDirection('forward', true, 'forward');
                                            window.history.pushState({}, 'Order.Place', window.location.href);
                                            // TODO: the history is still popped even the navigation is cancelled so we push it back to history stack.
                                            console.log('push state', window.location.href);
                                            _this.navigationService.deactivateResult.next(false);
                                            // this.navigationService.deactivateResult.complete();
                                        }
                                    },
                                    {
                                        text: _this.t.instant('buttons.leave'),
                                        handler: function () {
                                            // to do
                                            // this.googleAnalyticEventTrack('back-button-event', 'back');
                                            // const key = this.storeId + '.savedOrder';
                                            // this.configService.putPreference(key, null);
                                            _this.navigationService.isAlertingDeactive = false;
                                            _this.navigationService.deactivateResult.next(true);
                                            // this.navigationService.deactivateResult.complete();
                                            // super.backButtonClick();
                                            // return 'ok';
                                        }
                                    }
                                ]
                            });
                            console.log('make alert');
                            alert_1.then(function (data) {
                                console.log('alert created', data);
                                console.log('alert created', _this);
                                data.present().then(function (success) {
                                    console.log('success', success);
                                }, function (reject) {
                                    console.log('reject', reject);
                                });
                            });
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            });
        }
        return this.navigationService.deactivateResult;
    };
    ItemGridPage.prototype.goStore = function () {
        var _this = this;
        if (!this.isImplementGostore) {
            this.isImplementGostore = true;
            return;
        }
        var aimStore;
        this.stores.map(function (store) {
            if (store.id === Number(_this.selectedValue)) {
                aimStore = store;
            }
        });
        this.backBySwitchStore = false;
        var enableMutlOrder = this.multOrderManager.enableMutlOrder;
        var isExistOrder = enableMutlOrder ? this.multOrderManager.getOrderCount() > 0 : this.orderManager.count > 0;
        if (isExistOrder && !enableMutlOrder) {
            var alert_2 = this.alertController.create({
                header: this.t.instant('pages.brand-store-list.alert-title'),
                backdropDismiss: false,
                buttons: [
                    {
                        text: this.t.instant('buttons.cancel'),
                        handler: function () {
                            _this.isImplementGostore = false;
                            _this.selectedValue = _this.currentSelectedValue;
                        }
                    },
                    {
                        text: this.t.instant('buttons.leave'),
                        handler: function () {
                            _this.orderManager.clear();
                            // this.navigationService.deactivateResult.next(true);
                            _this.navigationService.poping = true;
                            _this.backBySwitchStore = true;
                            _this.currentSelectedValue = _this.selectedValue;
                            var temp = getCategoryPage(_this.systemConfigService, _this.settings.catLayout);
                            if (temp === 'ItemGridPage' || temp === 'ItemGridScrollPage') {
                                _this.navigationService.poping = true;
                                _this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
                            }
                            else {
                                _this.navController.pop().then(function () {
                                    _this.navigationService.poping = true;
                                    _this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
                                });
                            }
                        }
                    }
                ]
            });
            alert_2.then(function (data) {
                console.log('alert created', data);
                data.present().then(function (success) {
                    console.log('success', success);
                }, function (reject) {
                    console.log('reject', reject);
                });
            });
        }
        else {
            this.navigationService.poping = true;
            this.currentSelectedValue = this.selectedValue;
            var temp = getCategoryPage(this.systemConfigService, this.settings.catLayout);
            if (temp === 'ItemGridPage' || temp === 'ItemGridScrollPage') {
                this.navigationService.poping = true;
                this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
            }
            else {
                this.navController.pop().then(function () {
                    _this.navigationService.poping = true;
                    _this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
                });
            }
        }
        // this.navController.pop().then(() => this.storeClicked(aimStore));
    };
    ItemGridPage.prototype.tapSearch = function () {
        this.pushByName('SearchItemPage', { categories: this.categories, store: this.store, storeId: this.storeId });
    };
    ItemGridPage.prototype.settingMutlOrderManager = function () {
        if (this.multOrderManager.getOrderManager(this.storeId)) {
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
            this.orderManager.settingOrderType(this.orderManager.mode);
        }
        else {
            var orderManager = new OrderManager();
            orderManager.mode = this.orderManager.mode;
            orderManager.createOrder(this.storeId, null, null, null, this.store);
            this.addCourtReward(orderManager);
            this.multOrderManager.setOrderManagerMap(orderManager, this.storeId);
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
            this.orderManager.settingOrderType(this.orderManager.mode);
        }
    };
    ItemGridPage.prototype.catLayoutIsNone = function () {
        if (this.multOrderManager.enableMutlOrder) {
            this.settingMultOrderManager();
        }
        else if (this.orderManager.isEmpty()) {
            this.orderManager.createOrder(this.store.id, null, null, null, this.store);
            if (this.orderManager.mode === 'byod') {
                this.memberService.initMember('anno');
                this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
            }
        }
        this.orderManager.settingOrderType(this.orderManager.mode);
        this.showStore(this.store);
    };
    ItemGridPage.prototype.settingMultOrderManager = function () {
        if (this.multOrderManager.getOrderManager(this.storeId)) {
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
        }
        else {
            var orderManager = new OrderManager();
            orderManager.mode = this.orderManager.mode;
            orderManager.createOrder(this.store.id, null, null, null, this.store);
            this.addCourtReward(orderManager);
            this.multOrderManager.setOrderManagerMap(orderManager, this.storeId);
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
        }
    };
    ItemGridPage.prototype.showStore = function (store) {
        var now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        console.log('nowwwwww', now);
        var cats = this.menuManager.getAvailableCategories(store, now, this.orderManager.isTakeout());
        if (!cats) {
            return;
        }
        console.log('cats', cats);
        this.categories = this.categoryFilter(cats, []);
        if (!this.categories || this.categories.length === 0) {
            this.promptNoCat();
        }
        this.category = this.categories[0];
        this.orderManager.store = store;
    };
    ItemGridPage.prototype.promptNoCat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.noCat = true;
                        return [4 /*yield*/, this.alertController.create({
                                header: this.t.instant('pages.splash.no-cat-error'),
                                cssClass: 'sp-dineinTakeout-alert',
                                backdropDismiss: false,
                                buttons: [
                                    {
                                        text: this.t.instant('buttons.confirm'),
                                        handler: function () {
                                            // to do
                                            _this.backButtonClick();
                                        }
                                    }
                                ]
                            })];
                    case 1:
                        alert = _a.sent();
                        this.alert = alert;
                        this.alert.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridPage.prototype.categoryFilter = function (cats, types) {
        var result = [];
        var typeCat = {};
        var tmp = cats.filter(function (cat) {
            if (!cat.users || cat.users.length === 0) {
                return true;
            }
            else {
                var tmpSet = new Set(cat.users);
                for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                    var type = types_1[_i];
                    console.log(type + ' cat name:', cat.name);
                    if (tmpSet.has(type)) {
                        if (!typeCat[type]) {
                            typeCat[type] = [];
                        }
                        typeCat[type].push(cat);
                        break;
                    }
                }
                return false;
            }
        });
        for (var type in typeCat) {
            result = result.concat(typeCat[type]);
        }
        this.normalCategories = this.normalCategories.concat(tmp);
        result = result.concat(tmp);
        return result;
    };
    // ionViewDidEnter() {
    //     const element = document.getElementById('active');
    //     if (element) {
    //         element.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
    //     }
    // }
    ItemGridPage.prototype.ngOnInit = function () {
        var _this = this;
        this.initCategory(this.category);
        // 刚进页面储存显示的tittle
        if (this.isInfiniteScroll && this.lazyLoad) {
            this.displayItemsTittle.push(this.category.id);
        }
        var badges = this.store.menu.badges;
        if (badges) {
            badges.forEach(function (badge) {
                var tagImg = badge.getImage('default', 400, true);
                if (tagImg) {
                    _this.tagsImage[badge.tag] = tagImg;
                }
            });
        }
    };
    ItemGridPage.prototype.getCatMode = function (cat) {
        return cat && cat.layout && cat.layout !== 'none' ? cat.layout : this.settings.itemLayout;
    };
    ItemGridPage.prototype.ngAfterViewInit = function () {
        this.iniTime = Date.now();
        gtag('event', 'Page Initialize', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
            'value': 1
        });
        console.log('cate-to-grid level', this.orderService.gaTrack['cate-to-grid-level']);
        console.log('Enter time', this.iniTime);
        console.log('storeID', this.storeId);
        setTimeout(function () {
            try {
                var categoryElement = document.getElementById('active');
                // this.categoryBarRef.nativeElement.
                if (categoryElement) {
                    categoryElement.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            }
            catch (e) {
                console.error(e);
            }
        }, 500);
    };
    ItemGridPage.prototype.checkPopup = function (store) {
        return __awaiter(this, void 0, void 0, function () {
            var popupLocation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('TCL: checkPopup -> store', store);
                        popupLocation = 'welcome';
                        return [4 /*yield*/, this.layoutService.showPopup(store, popupLocation, function (data) {
                                console.log('ad data', data);
                                if (data && data.data) {
                                    var actionString = data.data.url;
                                    actionString = actionString.split('//')[1];
                                    // if (actionString === 'registration') {
                                    //     let page = this.memberService.getMember() ? MemberRewardPage : VerifyRegistrationPage;
                                    //     this.navController.push(page, {
                                    //         store: this.store,
                                    //         member: this.memberService.getMember(),
                                    //         fromPage: ByodSplashPage, logincb: () => {
                                    //             // this.next();
                                    //         }
                                    //     });
                                    // } else if (actionString === 'login' || actionString === 'loginbridge') {
                                    //     let page = null;
                                    //     if (actionString === 'login') {
                                    //         page = LoginPage;
                                    //     } else if (actionString === 'loginbridge') {
                                    //         page = LoginBridgePage;
                                    //     }
                                    //     // if(this.memberService.getMember())
                                    //     // {
                                    //     //     page = MemberRewardPage;
                                    //     // }
                                    //     if (page) {
                                    //         this.navController.push(page, {
                                    //             store: this.store,
                                    //             fromPage: ByodSplashPage, logincb: () => {
                                    //                 // this.next();
                                    //             }
                                    //         });
                                    //     }
                                    // }
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridPage.prototype.ionViewDidEnter = function () {
        this.enterTime = Date.now();
        console.log('Enter time', this.enterTime);
        if (this.isInfiniteScroll)
            this.afterLastItemLoadJump();
    };
    ItemGridPage.prototype.afterLastItemLoadJump = function () {
        var _this = this;
        var element = document.getElementById('active');
        console.log('afterLastItemLoadJump');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
        if (this.isInfiniteScroll) {
            var arr = [];
            if (!this.catList) {
                return;
            }
            this.catList && arr.push.apply(arr, this.catGrid2['_results'].concat(this.catGrid3['_results'], this.catList['_results']));
            arr.forEach(function (ele) {
                var index = ele['el'].id.slice(3) * 1;
                // console.log("index",ele['el'].id.slice(3))
                _this.catTitHeightArr[index] = ele['el'].offsetTop;
            });
            // console.log("height",this.catTitHeightArr);
            this.header = this.catTitHeightArr[0];
            this.catTitHeightArr.shift();
            this.catTitHeightArr = this.catTitHeightArr.map(function (el) {
                return el - _this.header;
            });
            this.jumpToFloor(this.category);
        }
    };
    ItemGridPage.prototype.contentScrolling = function (event) {
        var _this = this;
        this.content.getScrollElement().then(function (el) {
            for (var i = 0; i < _this.categories.length; i++) {
                if (el.scrollTop < _this.catTitHeightArr[0]) {
                    _this.category = _this.categories[0];
                    _this.adjustBar();
                    break;
                }
                else {
                    if (_this.catTitHeightArr[i + 1] && el.scrollTop < _this.catTitHeightArr[i + 1]) {
                        _this.category = _this.categories[i + 1] ? _this.categories[i + 1] : _this.categories[i];
                        // console.log('2', this.category);
                        _this.adjustBar();
                        break;
                    }
                    if (!_this.catTitHeightArr[i + 1]) {
                        _this.category = _this.categories[_this.categories.length - 1];
                        // console.log('3', this.category);
                        _this.adjustBar();
                        break;
                    }
                }
            }
        });
    };
    // 获取对应元素的距离顶部距离
    // findHeight(elArr,i){
    //     let height:number;
    //     console.log("findHeight",this.header)
    //     elArr['_results'].forEach(el => {
    //         if(el['el'].id === "cat"+i){
    //             console.log("height",el['el'].offsetTop,this.header);
    //             height = el['el'].offsetTop-this.header;
    //         }
    //     });
    //     return height;
    // }
    ItemGridPage.prototype.ngOnDestroy = function () {
        var needAlert = true;
        // need a flag
        if (this.settings && this.settings.catLayout) {
            needAlert = this.settings.catLayout === 'none';
        }
        if (!this.multOrderManager.enableMutlOrder && needAlert) {
            this.orderManager.clear();
        }
        if (this.alert) {
            this.alert.dismiss();
        }
    };
    ItemGridPage.prototype.initCategory = function (cat) {
        var _this = this;
        this.category = cat;
        if (this.isInfiniteScroll && this.catTitHeightArr.length > 0) {
            // 确保节点获取到
            timer(800).subscribe(function () {
                _this.jumpToFloor(_this.category);
            });
        }
        this.bannerImg = this.category.getImage('banner', 500, false);
        console.log('category banner', this.bannerImg);
        // const imgCount = 0;
        // const filter: (Item) => boolean = (item) => this.isPublish(item);
        this.variations = {};
        var allItems = this.getAllAvailableItems();
        if (!this.lazyLoad && this.isInfiniteScroll) {
            console.log('infinteScroll layout');
            this.displayCat = allItems;
            // allItems是一个以catId为键,catItems为值的对象
            // 处理图片
            var imgsObj = {};
            var filterItemsObj = {};
            for (var catId in allItems) {
                filterItemsObj[catId] = [];
                imgsObj[catId] = [];
                for (var _i = 0, _a = allItems[catId]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    if (item) {
                        filterItemsObj[catId].push(item);
                        var img = void 0;
                        if (this.mode === 'list') {
                            img = item.getImage('default', 100, false);
                        }
                        else {
                            img = item.getImage('default', 150, true);
                        }
                        if (img) {
                            imgsObj[catId].push(img);
                        }
                        else {
                            if (this.defaultImage) {
                                imgsObj[catId].push(this.defaultImage);
                            }
                            else {
                                imgsObj[catId].push(null);
                            }
                        }
                    }
                }
            }
            this.imgsObj = imgsObj; // 保存图片
            this.allItems = filterItemsObj; // 保存类别信息
        }
        else if (this.lazyLoad && this.isInfiniteScroll) {
            // allItems是一个包含所有catItems的数组
            // todo 处理懒加载数据
        }
        else {
            // 关闭滚动ion-content scrolling-event
            this.isIonContentScroll = false;
            console.log('原始layout');
            this.displayCat = {};
            this.displayCat[this.category.id] = allItems[this.category.id];
            var items = this.menuManager.getAvailableMainItems(this.store, this.category, this.orderManager.isTakeout());
            var filterItems = [];
            this.imgs = [];
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                if (item) {
                    filterItems.push(item);
                    var img = void 0;
                    if (this.mode === 'list') {
                        img = item.getImage('default', 100, false);
                    }
                    else {
                        img = item.getImage('default', 150, true);
                    }
                    if (img) {
                        this.imgs.push(img);
                    }
                    else {
                        if (this.defaultImage) {
                            this.imgs.push(this.defaultImage);
                        }
                        else {
                            this.imgs.push(null);
                        }
                    }
                }
            }
            this.items = filterItems;
            // console.log(this.items)
            // rm no Image show list logic for first cat
            // if(withoutImage){
            //     this.mode = "list";
            // }else{
            //     this.mode = this.getNavParams("layout") ? this.getNavParams("layout"):"grid";
            // }
        }
        if (this.isCatLayoutNone) {
            this.mode = this.category.layout && this.category.layout !== 'none' ? this.category.layout : this.settings.itemLayout;
        }
        if (!this.mode || this.mode === 'none') {
            this.mode = 'grid';
        }
        this.groups = cat.groups;
        // this.infiniteIsHidden = this.items.length === 0;
        // let infiniteScroll = new InfiniteScrollItems(this.items,9);
        // this.displayItems = infiniteScroll.getShowArray();
        // this.infiniteScroll = infiniteScroll;
    };
    ItemGridPage.prototype.loadMoreItems = function (event) {
        var _this = this;
        this.displayItems = this.infiniteScroll.loadMore(event, function () {
            _this.infiniteIsHidden = true;
        });
        this.maked(this.category);
        // console.log(this.displayItems,this.allItems)
    };
    // 获取所有category可用的items,不只是某一类别的items
    ItemGridPage.prototype.getAllAvailableItems = function () {
        if (this.categories) {
            var lengthOfEachCategoryItems = 0;
            var allItems = {};
            var allItemsArray = [];
            for (var _i = 0, _a = this.categories; _i < _a.length; _i++) {
                var cat = _a[_i];
                var itemsOfEachCategory = this.menuManager.getAvailableMainItems(this.store, cat, this.orderManager.isTakeout());
                if (!this.lazyLoad) {
                    allItems[cat.id] = itemsOfEachCategory;
                }
                else {
                    allItemsArray.push.apply(allItemsArray, itemsOfEachCategory);
                } // 构建一个存放所有类别的子元素的数组,用来进行懒加载
                lengthOfEachCategoryItems += itemsOfEachCategory.length;
                this.lengthArrayOfEachCategoryItems.push(lengthOfEachCategoryItems); // 存放前i个类别数组的子元素总数
            }
            console.log('allItems', allItems);
            console.log('allItemsArray', allItemsArray);
            if (this.lazyLoad) {
                // todo 获取所有数据后,只拿取一部分显示,懒加载
                // this.infiniteIsHidden = this.allItemsArray.length === 0;
                // let infiniteScroll = new InfiniteScrollItems(this.allItemsArray,9);
                // this.displayItems = infiniteScroll.getShowArray();//只是显示的数据,不包含类别信息
                // this.maked(this.category);//构造新的数据用来ngFor循环生成新的html
                // this.infiniteScroll = infiniteScroll;
                return allItemsArray;
            }
            else {
                return allItems;
            }
        }
    };
    // 根据displayItems和this.category的形式构造新数据赋予 this.allItems
    ItemGridPage.prototype.maked = function (cat) {
        var i = this.categories.indexOf(cat); // 0 1
        var old = (i === 0 ? 0 : this.lengthArrayOfEachCategoryItems[i - 1]); // 0 15
        var start = this.lengthArrayOfEachCategoryItems[i]; // 15 26
        var end = this.lengthArrayOfEachCategoryItems[i + 1]; // 26 28
        if (this.displayItems.length > start) { // 18>15
            // 有了新一类
            // 1.把旧一类补全
            this.allItems[cat.id] = this.displayItems.slice(old, start);
            if (this.categories[i + 1]) { // 新类别存在
                // 2.获取新的类别
                cat = this.categories[i + 1];
                // 存储应该显示的tittle
                this.displayItemsTittle.push(cat.id);
                this.allItems[cat.id] = [];
                // 剪切新的一类数据
                var newEnd = this.displayItems.length >= end ? end : this.displayItems.length;
                this.allItems[cat.id] = this.displayItems.slice(start, newEnd);
                // 懒加载的数据在剪完新的一类数据后还能再创新的一个类别,自调用
                if (this.displayItems.length > newEnd) {
                    this.maked(cat);
                }
            }
            else {
                return;
            }
        }
        else {
            this.allItems[cat.id] = this.displayItems;
            return;
        }
    };
    // 过滤出对应类别应该显示的tittle
    ItemGridPage.prototype.filterDisplayItemsTittle = function (id) {
        return this.lazyLoad ? this.displayItemsTittle.includes(id) : true;
    };
    // 调整bar的相应的类别
    ItemGridPage.prototype.adjustBar = function (str) {
        // timer(300).subscribe(()=>{
        var element = document.getElementById('active');
        // console.log("active cat:",element);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            // console.log('move');
        }
        // })
    };
    ItemGridPage.prototype.showEmpty = function (catId, index) {
        if (this.isInfiniteScroll) {
            this.imgsObj[catId][index] = this.defaultImage;
        }
        else {
            this.imgs[index] = this.defaultImage;
        }
    };
    ItemGridPage.prototype.isSet = function (item) {
        /*
        if(item.groups && item.groups.length > 0){
            return true;
        }
        if(this.category.groups && this.category.groups.length > 1){

            return true;
        }

        return false;*/
        return Item.isSet(this.findCategory(item), item);
    };
    ItemGridPage.prototype.findCategory = function (item) {
        var result = null;
        if (this.categoryMap[item.id]) {
            result = this.categoryMap[item.id];
        }
        else {
            var obj_1;
            this.categories.length > 0 && this.categories.map(function (category, index) {
                if (!obj_1) {
                    for (var i = 0; i < category.groups[0].items.length; i++) {
                        if (item.id === category.groups[0].items[i].id) {
                            obj_1 = category;
                            break;
                        }
                    }
                }
            });
            this.categoryMap[item.id] = obj_1;
            result = obj_1;
        }
        return result;
    };
    ItemGridPage.prototype.addItem = function (item) {
        // this.orderService.addSingleItem(this.category, this.groups[0], item);
        var oi = this.orderManager.addSingleItem(this.findCategory(item), this.findCategory(item).groups[0], item, false);
        this.orderManager.getQuantity(item);
        if (!(this.isRequiredModifier(item) || (this.isModifiable(item) && !this.settings.quickSingleItem))) {
            // this.showToast(this.t.instant('global.item-added'), 600, 'bottom', 'add-item-toast');
        }
        return oi;
    };
    ItemGridPage.prototype.cartClicked = function () {
        console.log('cart clicked');
        gtag('event', 'GRID to CART page time spent(ms)', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
            'value': Date.now() - this.enterTime
        });
        this.orderService.gaTrack['grid-to-cart-level'] += 1;
        gtag('event', 'Switch tab Count per level', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
            'value': this.tabClickCount
        });
        gtag('event', 'Set clicked Count per level', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
            'value': this.setClickCount
        });
        //   reset the tabClick of this level
        this.tabClickCount = 1;
        this.setClickCount = 0;
        if (this.multOrderManager.enableMutlOrder ? this.multOrderManager.getOrders.length <= 0 : this.orderManager.isEmpty()) {
            var warning = this.t.instant('global.order-first');
            var confirm_1 = this.t.instant('buttons.ok');
            this.showAlert('', warning, [confirm_1]);
        }
        else {
            this.pushByName((this.multOrderManager.enableMutlOrder ? 'MultiOrderCartPage' : 'CartScrollPage'), { store: this.store });
        }
    };
    ItemGridPage.prototype.showAlertControlBDDismiss = function (title, message, buttons, enableBackdropDismiss) {
        if (buttons === void 0) { buttons = ['OK']; }
        if (enableBackdropDismiss === void 0) { enableBackdropDismiss = true; }
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!buttons) {
                            buttons = ['OK'];
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: title,
                                subHeader: message,
                                buttons: buttons,
                                backdropDismiss: enableBackdropDismiss
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/, alert];
                }
            });
        });
    };
    ItemGridPage.prototype.addClicked = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var t, page, params, _a, navComponent, cssClass, cate_1, oi, _groups, groups, oi, handler;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('add clicked');
                        return [4 /*yield*/, this.isVariationParent(item)];
                    case 1:
                        t = _b.sent();
                        console.log('variation parent', t);
                        if (t) {
                            return [2 /*return*/];
                        }
                        if (this.isSoldout(item)) {
                            return [2 /*return*/];
                        }
                        if (!this.orderManager.isUsablePointsEnough(item)) {
                            this.showAlert('', this.t.instant('pages.item-grid.not-enough-point'));
                            return [2 /*return*/];
                        }
                        if (this.checkStoreMaxItem()) {
                            this.showStoreMaxItemAlert();
                            return [2 /*return*/];
                        }
                        if (this.isSet(item)) {
                            page = getSetLayout(this.orderManager.store.menu.setLayout);
                            params = {
                                // this.pushByName(page, {
                                store: this.store,
                                category: this.findCategory(item),
                                groups: this.findCategory(item).groups,
                                // category: this.category,
                                // groups: this.category.groups,
                                item: item,
                                handler: this.getNavParams('handler')
                                // }, {
                                //     relativeTo: this.route,  // replaceUrl: true,
                                //     skipLocationChange: false
                                // });
                            };
                            console.log('set layout', page);
                            _a = this.getComboItemSettingToPageAndCss(), navComponent = _a.navComponent, cssClass = _a.cssClass;
                            gtag('event', 'Page from ENTERED to ADD COMBO time spent(ms)', {
                                'event_category': this.store.name + '(Item Grid Page)',
                                'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
                                'value': Date.now() - this.enterTime
                            });
                            this.navToAssignLayoutItems(navComponent, page, params, {
                                relativeTo: this.route,
                                skipLocationChange: false
                            }, cssClass);
                        }
                        else {
                            // if cannot skip modifier page
                            if (this.isRequiredModifier(item) || (this.isModifiable(item) && !this.store.menu.quickSingleItem)) {
                                cate_1 = this.findCategory(item);
                                oi = this.addItem(item);
                                console.log('oi', oi);
                                _groups = cate_1.groups, groups = _groups && _groups.filter(function (group) {
                                    var now = _this.convertNowDateToStoreTimeZone(_this.store.timezone).getTime();
                                    return _this.menuManager.isAvailableGroup(_this.store, cate_1, group, _this.orderManager.order.takeout, now, false);
                                });
                                this.add(item, groups[0], oi);
                                // this.pushByName('ModifierItemSelectPage', {store: this.store, orderitem: oi}, {
                                //     relativeTo: this.route,
                                //     //  // replaceUrl: true,
                                //     skipLocationChange: false
                                // });
                            }
                            else {
                                oi = this.addItem(item);
                                {
                                    if (!this.categories) {
                                        handler = this.getNavParams('handler');
                                        handler(oi);
                                        this.orderManager.minusItem(item, true);
                                        this.navigationService.popPage();
                                    }
                                }
                            }
                        }
                        if (this.orderService.isCourt) {
                            this.gaService.eventTrack('item-list-page', 'select item - ' + this.store.name, item.name);
                        }
                        this.cd.detectChanges();
                        this.bounce();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridPage.prototype.getGroupMode = function (group) {
        return group.repeat ? 'quantity' : 'single';
    };
    ItemGridPage.prototype.isGroupCompleted = function (group, index, quantity) {
        // console.log(group);
        if (!group) {
            return true;
        }
        if (group.min <= quantity || quantity === group.max) {
            return true;
        }
        if (group.optional) {
            if (group.skippable) {
                return true;
            }
            else {
                return index === -1;
            }
        }
        return false;
    };
    ItemGridPage.prototype.presentModifierPopup = function (store, orderItem, group, itemMap, page, handler, showLastOne) {
        return __awaiter(this, void 0, void 0, function () {
            var input, cssClass, modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = { store: store, orderitem: orderItem, group: group, itemMap: itemMap, side: true };
                        if (showLastOne) {
                            input['showLastOne'] = showLastOne;
                        }
                        cssClass = this.getModifierDailogAndCss().cssClass;
                        return [4 /*yield*/, this.modalController.create({
                                component: page,
                                componentProps: input,
                                animated: true,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: cssClass
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (confirm) {
                            if (handler) {
                                handler(confirm);
                            }
                        });
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridPage.prototype.getComboQuantity = function (item) {
        var order = this.orderManager.getOrder();
        if (order && order.orderitems && order.orderitems.length === 0) {
            return 0;
        }
        var finds = order.orderitems.filter(function (o) {
            var items = o.items || [];
            return items.find(function (i) {
                return i.id === item.id;
            });
        });
        return finds.length;
        // order.orderitems
    };
    ItemGridPage.prototype.hasModifier = function (items, itemMap, checkRequired) {
        if (checkRequired === void 0) { checkRequired = false; }
        var required = false;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            var tmpItem = itemMap[item.id];
            if (tmpItem && tmpItem.mgroups && tmpItem.mgroups.length > 0) {
                if (checkRequired) {
                    for (var _a = 0, _b = tmpItem.mgroups; _a < _b.length; _a++) {
                        var mgroup = _b[_a];
                        if (mgroup.min && mgroup.min > 0) {
                            required = true;
                            break;
                        }
                    }
                }
                else {
                    required = true;
                    break;
                }
            }
        }
        return required;
    };
    ItemGridPage.prototype.handlingModifier = function (oi, item, itemMap, addHandler, notAddHandler, showLastOne) {
        if (showLastOne === void 0) { showLastOne = false; }
        var group = oi.groups[0];
        var items = [];
        items.push(item);
        var req = this.hasModifier(items, itemMap, this.settings.quickSingleItem);
        var modifierDailogModal = this.getModifierDailogAndCss().modifierDailogModal;
        if (req) {
            this.presentModifierPopup(this.store, oi, group, itemMap, modifierDailogModal, function (confirm) {
                if (confirm && confirm['data']) {
                    addHandler();
                }
                else {
                    notAddHandler(item);
                }
            }, showLastOne);
        }
        else {
            addHandler();
        }
    };
    ItemGridPage.prototype.add = function (item, group, oi, isPreselect) {
        var _this = this;
        if (isPreselect === void 0) { isPreselect = false; }
        var groupIndex = item.groups.findIndex(function (g) {
            // TODO: is compared by id safe?
            return (g !== null && g !== undefined && g.id === group.id);
        }) + 1;
        var isOptional = group.min === 0;
        if (this.getGroupMode(group) === 'single') {
            // special request only can change isSelected
            var max = group.max;
            var able = true;
            if (!isPreselect) {
                if (this.isGroupCompleted(group, groupIndex, 1)) {
                    this.handlingModifier(oi, item, this.itemMap, function () {
                    }, function () {
                        // this.minusClicked(item, group);
                        _this.removeClicked(item);
                    });
                }
                else if (isOptional) {
                    var realItem = item;
                    if (realItem.mgroups && realItem.mgroups.length > 0) {
                        this.handlingModifier(oi, item, this.itemMap, function () {
                            // this.showToast(this.t.instant('global.item-added'));
                        }, function () {
                            // this.minusClicked(item, group);
                            _this.removeClicked(item);
                        }, true);
                    }
                }
            }
        }
        else if (this.getGroupMode(group) === 'quantity') {
            // special request can change the number
        }
    };
    ItemGridPage.prototype.removeClicked = function (item) {
        console.log('remove clicked');
        // this.orderService.deleteItem(item);
        // this.orderService.minusItem(item);
        this.orderManager.minusItem(item, true);
    };
    ItemGridPage.prototype.bounce = function () {
        var _this = this;
        this.isBounce = true;
        setTimeout(function () {
            _this.isBounce = false;
        }, 400);
    };
    ItemGridPage.prototype.getModifierString = function (item) {
        var modifiers = '+';
        var groups = this.category.groups;
        if (item.groups && item.groups.length > 0) {
            groups = item.groups;
        }
        else {
            groups = groups.slice(1);
        }
        groups = groups.filter(function (group) { return group.items && group.items.length > 0; });
        if (!groups || groups.length === 0) {
            return '';
        }
        return modifiers + groups.map(function (group) { return group.name; }).join(' +');
    };
    ItemGridPage.prototype.triggerFab = function () {
        this.googleAnalyticEventTrack('menu');
        this.isfabOpen = !this.isfabOpen;
        if (!this.isfabOpen) {
            this.googleAnalyticEventTrack('close menu', 'open menu');
        }
    };
    // 点击catbar
    ItemGridPage.prototype.catClicked = function (fab, cat) {
        var _this = this;
        if (this.isfabOpen) {
            this.googleAnalyticEventTrack('choose cate', 'open menu');
        }
        var warning = (cat && cat['warning']) || null;
        if (warning /* && StaticService.canShowWarning*/) {
            var buttons = [
                {
                    text: this.t.instant('buttons.cancel'),
                    handler: function (value) {
                    }
                },
                {
                    text: this.t.instant('buttons.ok'),
                    handler: function (value) {
                        if (_this.isInfiniteScroll) {
                            _this.category = cat;
                            _this.jumpToFloor(cat);
                        }
                        else {
                            _this.initCategory(cat);
                            _this.content.scrollToPoint(0, 0);
                        }
                        _this.mode = cat.layout && cat.layout !== 'none' ? cat.layout : _this.settings.itemLayout;
                        if (!_this.mode || _this.mode === 'none') {
                            _this.mode = 'grid';
                        }
                        _this.isfabOpen = false;
                        // TODO: scroll to top?
                        // this.content.scrollToTop(100);
                        // fab.close();
                    }
                }
            ];
            this.showAlertControlBDDismiss(null, warning, buttons, false);
        }
        else {
            if (this.isInfiniteScroll) {
                this.category = cat;
                this.jumpToFloor(cat);
            }
            else {
                this.initCategory(cat);
                this.content.scrollToPoint(0, 0);
            }
            this.mode = cat.layout && cat.layout !== 'none' ? cat.layout : this.settings.itemLayout;
            if (!this.mode || this.mode === 'none') {
                this.mode = 'grid';
            }
            this.isfabOpen = false;
            // TODO: scroll to top?
            // this.content.scrollToTop(100);
            // fab.close();
        }
    };
    // 跳到相应的楼层
    ItemGridPage.prototype.jumpToFloor = function (cat) {
        var _this = this;
        var i = this.categories.indexOf(cat);
        this.isIonContentScroll = false;
        // console.log('跳跃前',this.isIonContentScroll,i,cat.layout,this.catGrid3);
        var point = i === 0 ? 0 : this.catTitHeightArr[i - 1];
        console.log('point', point);
        this.content.scrollToPoint(0, point);
        // if(cat.layout=='grid')
        //     this.content.scrollToPoint(0,this.findHeight(this.catGrid2,i));
        // else if(cat.layout=='list')
        //     this.content.scrollToPoint(0,this.findHeight(this.catList,i));
        // else
        //     this.content.scrollToPoint(0,this.findHeight(this.catGrid3,i));
        timer(100).subscribe(function () {
            _this.isIonContentScroll = true;
            // console.log('跳跃后',this.isIonContentScroll,this.findHeight(this.catGrid3,i));
        });
    };
    ItemGridPage.prototype.checkStoreMaxItem = function () {
        var maxItems = this.orderManager.store.menu.maxItems;
        var infinity = maxItems === 0;
        return (maxItems <= this.orderManager.count && !infinity);
    };
    ItemGridPage.prototype.getItemName = function (item) {
        var name = item.name;
        if (this.isParent(item)) {
            name = item.title;
        }
        if (!name || name.length === 0) {
            name = item.name;
        }
        return name;
    };
    ItemGridPage.prototype.backButtonClick = function () {
        console.log('back click');
        this.orderService.gaTrack['cate-to-grid-level'] += 1;
        if (this.navigationService.poping || this.navigationService.navigating) {
            return;
        }
        gtag('event', 'Page from ENTERED to BACK DESTROY time spent(ms)', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
            'value': Date.now() - this.iniTime
        });
        var needAlert = true;
        // need a flag
        if (this.settings && this.settings.catLayout) {
            needAlert = this.settings.catLayout === 'none';
        }
        // if (!this.multOrderManager.enableMutlOrder && needAlert && this.orderManager.getOrder().orderitems.length !== 0) {
        //     const alert = this.alertController.create({
        //         header: this.t.instant('pages.brand-store-list.alert-title'),
        //         buttons: [
        //             {
        //                 text: this.t.instant('buttons.cancel'),
        //                 handler: () => {
        //                     // to do
        //                     // this.googleAnalyticEventTrack('back-button-event', 'cancel');
        //                 }
        //             },
        //             {
        //                 text: this.t.instant('buttons.ok'),
        //                 handler: () => {
        //                     // to do
        // this.googleAnalyticEventTrack('back-button-event', 'back');
        // super.backButtonClick();
        //                 }
        //             }
        //         ]
        //     });
        //     alert.then(data => data.present());
        // } else {
        _super.prototype.backButtonClick.call(this);
        // }
    };
    ItemGridPage.prototype.isModifiable = function (item) {
        if (!this.modifiableMap[item.id]) {
            this.modifiableMap[item.id] = Item.isModifiable(item);
        }
        return this.modifiableMap[item.id];
    };
    ItemGridPage.prototype.isRequiredModifier = function (item) {
        if (this.isModifiable(item)) {
            if (!this.requiredModifierMap[item.id]) {
                this.requiredModifierMap[item.id] = item.mgroups.some(function (mgroup) { return mgroup.min > 0; });
            }
            return this.requiredModifierMap[item.id];
        }
        else {
            return false;
        }
    };
    // new list function //
    ItemGridPage.prototype.getImage = function (data) {
        if (this.imageMap[data.id]) {
            return this.imageMap[data.id];
        }
        else {
            var img = data.getImage('default', 150, true);
            this.imageMap[data.id] = img;
            return img;
        }
    };
    ItemGridPage.prototype.isSoldout = function (item) {
        var result = false;
        if (this.itemSoldoutMap[item.id]) {
            var cache = this.itemSoldoutMap[item.id];
            result = !!cache['soldout'];
        }
        else {
            var imSoldout = this.inventoryManager.isSoldout(item);
            result = (!this.isParent(item) && imSoldout);
            this.itemSoldoutMap[item.id] = { 'soldout': result };
        }
        var now = this.convertNowDateToStoreTimeZone(this.store.timezone).getTime();
        return result || !this.menuManager.isAvailableCombo(this.store, this.category, item, this.orderManager.isTakeout(), now);
    };
    ItemGridPage.prototype.pageName = function () {
        return '/item-grid';
    };
    ItemGridPage.prototype.isVariationParent = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var exist, items, options, input, _a, component, cssClass, modal;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        exist = this.isParent(item);
                        if (!exist) return [3 /*break*/, 2];
                        items = item.variations.slice(0) || [];
                        if (item.id === item.parentId) {
                            items.splice(0, 0, item);
                        }
                        else {
                            items.push(item);
                        }
                        options = { showBackdrop: true, backdropDismiss: true, cssClass: 'modal-largescreen' };
                        input = { items: items, store: this.store, category: this.category, orderManager: this.orderManager };
                        _a = this.getVariationModalComponentAndCss(), component = _a.component, cssClass = _a.cssClass;
                        return [4 /*yield*/, this.modalController.create({
                                component: component,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: cssClass,
                                animated: true
                            })];
                    case 1:
                        modal = _b.sent();
                        modal.onWillDismiss().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var selected, page, params, _a, navComponent, cssClass_1, oi, params, _b, modifierModal, cssClass_2, m;
                            var _this = this;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        selected = (data['data']);
                                        if (!selected) return [3 /*break*/, 3];
                                        console.log('select & add item');
                                        if (this.checkStoreMaxItem()) {
                                            this.showStoreMaxItemAlert();
                                            return [2 /*return*/];
                                        }
                                        if (!(this.isSet(selected) || selected.pgroup)) return [3 /*break*/, 1];
                                        page = getSetLayout(this.orderManager.store.menu.setLayout);
                                        params = {
                                            store: this.store,
                                            category: this.findCategory(item),
                                            groups: this.findCategory(item).groups,
                                            item: selected
                                        };
                                        console.log('set layout', page);
                                        gtag('event', 'Page from ENTERED to ADD COMBO(has parent) time spent(ms)', {
                                            'event_category': this.store.name + '(Item Grid Page)',
                                            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
                                            'value': Date.now() - this.enterTime
                                        });
                                        _a = this.getVariationModalDismissToPageAndCss(), navComponent = _a.navComponent, cssClass_1 = _a.cssClass;
                                        this.navToAssignLayoutItems(navComponent, page, params, {
                                            relativeTo: this.route,
                                            skipLocationChange: false
                                        }, cssClass_1);
                                        return [3 /*break*/, 3];
                                    case 1:
                                        oi = this.addItem(selected);
                                        if (!(this.isRequiredModifier(selected) || (this.isModifiable(selected) && !this.store.menu.quickSingleItem))) return [3 /*break*/, 3];
                                        params = { store: this.store, orderitem: oi, edit: true };
                                        _b = this.getAfterSelectedToModifierModalAndCss(), modifierModal = _b.modifierModal, cssClass_2 = _b.cssClass;
                                        return [4 /*yield*/, this.modalController.create({
                                                component: modifierModal,
                                                componentProps: params,
                                                cssClass: cssClass_2
                                            })];
                                    case 2:
                                        m = _c.sent();
                                        m.onDidDismiss().then(function (data) {
                                            console.log('ModifierItemSelectPageModal res', data);
                                            if (data['data'] === 'confirm') {
                                                // do....
                                                // this.showToast(this.t.instant('global.item-added'));
                                            }
                                            else {
                                                _this.removeClicked(selected);
                                            }
                                        });
                                        m.present();
                                        return [3 /*break*/, 3];
                                    case 3:
                                        this.isVariationOpened = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.isVariationOpened = true;
                        modal.present();
                        _b.label = 2;
                    case 2: return [2 /*return*/, exist];
                }
            });
        });
    };
    ItemGridPage.prototype.isParent = function (item) {
        return !!(item.variations && item.variations.length > 0);
    };
    // when orderItem-click is combo-groups , show the variation-modal
    ItemGridPage.prototype.getVariationModalComponentAndCss = function () {
        var component, cssClass;
        var layout = getSetLayout(this.settings.setLayout);
        if (layout === 'ComboPage') {
            component = VariationScrollDialog;
            cssClass = 'modal-largescreen';
        }
        else {
            component = VariationDialog;
            cssClass = 'modal-largescreen';
        }
        return { component: component, cssClass: cssClass };
    };
    // when variations-modal selected and will popup the combo-setting-page
    ItemGridPage.prototype.getVariationModalDismissToPageAndCss = function () {
        var navComponent, cssClass;
        var layout = getSetLayout(this.settings.setLayout);
        if (layout === 'ComboPage') {
            navComponent = ComboPage;
            cssClass = 'modal-largescreen set-list-view combo-modal-backdrop-dismiss';
        }
        else {
            navComponent = MultiStepComboPage;
            cssClass = '';
        }
        return { navComponent: navComponent, cssClass: cssClass };
    };
    // when the combo is only one and popup the combo-setting-page
    ItemGridPage.prototype.getComboItemSettingToPageAndCss = function () {
        var navComponent, cssClass;
        var layout = getSetLayout(this.settings.setLayout);
        if (layout === 'ComboPage') {
            navComponent = ComboPage;
            cssClass = 'modal-largescreen combo-modal-backdrop-dismiss';
        }
        else {
            navComponent = MultiStepComboPage;
            cssClass = '';
        }
        return { navComponent: navComponent, cssClass: cssClass };
    };
    // when variations-modal selected and but not require to combo-setting-page but to modifierMdal
    ItemGridPage.prototype.getAfterSelectedToModifierModalAndCss = function () {
        var modifierModal, cssClass;
        var layout = getSetLayout(this.settings.setLayout);
        if (layout === 'ComboPage') {
            modifierModal = ModifierItemSelectPageModal;
            cssClass = 'modal-largescreen variation-item-modifier-select ';
        }
        else {
            modifierModal = ModifierItemSelectPageModal;
            cssClass = '';
        }
        return { modifierModal: modifierModal, cssClass: cssClass };
    };
    // when orderItem is alercat and need to popup modifier-seeting-modal
    ItemGridPage.prototype.getModifierDailogAndCss = function () {
        var modifierDailogModal, cssClass;
        var layout = getSetLayout(this.settings.setLayout);
        if (layout === 'ComboPage') {
            modifierDailogModal = SideBarModifierDialog;
            cssClass = 'modal-largescreen modifier-modal ';
        }
        else {
            modifierDailogModal = ModifierDialog;
            cssClass = 'modal-largescreen modifier-modal side-modifier';
        }
        return { modifierDailogModal: modifierDailogModal, cssClass: cssClass };
    };
    return ItemGridPage;
}(MobileBasePage));
export { ItemGridPage };
